export const LOCALE_DK = {
    ORDER: "Bestilling",
    INVOICE: "Faktura",
    INVOICES: "Fakturaer",
    PROFORMA_INVOICES: "Proformafakturaer",
    CREDIT_NOTE: "Kreditnota",
    CREDIT_NOTES: "Kreditnotaer",
    CREATION_DATE: "Udstedelsesdato",
    DELIVERY_DATE: "Leveringsdato",
    DELIVERY_ADDRESS: "Leveringsadresse",
    DELIVERY_COST: "Leveringsgebyr",
    VENDOR: "Leverandør",
    CUSTOMER: "Kunde",
    ORDER_NUMBER: "Ordrenummer",
    PAYMENT_METHOD: "Betalingsmetode",
    NOTE: "Bemærkning",
    PRODUCT: "Vare",
    PRODUCT_DESCRIPTION: "Beskrivelse",
    PRODUCT_AMOUNT: "Antal",
    PRODUCT_SINGLE_PRICE: "Stykspris",
    DISCOUNT: "Rabat",
    TOTAL_DISCOUNTS: "Samlet rabat",
    TOTAL_BEFORE_DISCOUNTS: "Samlet før rabat",
    TAX_ABBREVIATED: "Moms",
    TAX_AMOUNT: "Skattebeløb",
    SPLIT_AMOUNT: "Andel",
    BRUTTO: "Brutto",
    TOTAL: "Total",
    TOTAL_INCLUDING_VAT: "Total inkl. moms",
    TOTAL_EXCLUDING_VAT: "Total ekskl. moms",
    VAT_ID: "Momsregistreringsnummer",
    TAX_ID: "Skatteregistreringsnummer",
    PAID: "Betalt",
    UNPAID_AMOUNT: "Ubetalt beløb",
    REASON: "Årsag",
    INVOICE_LINE_ITEMS_TITLE: "Ordreposter",
    CREDIT_NOTES_LINE_ITEMS_TITLE: "Kreditnotaer på ordreposter",
    OTHER_CREDIT_NOTES: "Justering af ordren",
    REFUND_SHIPPING_COST: "Returneringsomkostninger",
    REFUND_HAS_BEEN_PAID: "Der blev udbetalt en refusion på $VALUE.",
    REFUND_HAS_BEEN_PAID_FAILED: "Der opstod en fejl under refusionen på $VALUE.",
    DOCUMENTS_FOR_ORDER: "Dokumenter til ordren",
    NO_INVOICES: "Ingen fakturaer tilgængelige endnu",
    NO_CREDIT_NOTES: "Ingen kreditnotaer tilgængelige endnu",
    DOCUMENTS_ARE_GENERATING: "Fakturadokumenter bliver genereret i øjeblikket. Prøv igen om et par minutter.",
    INVALID_REQUEST_PATHWAY_SUPPORT: "Ingen dokumenter kunne findes til denne ordre. Kontakt venligst support@pathway-solutions.de.",
    INVALID_REQUEST_GENERIC: "Ingen dokumenter kunne findes til denne ordre. Kontakt venligst den pågældende forhandler.",
    INVALID_REQUEST_INDIVIDUAL_SUPPORT: "Ingen dokumenter kunne findes til denne ordre. Kontakt venligst ${MAIL}.",
    GIFT_CARD_LINE: "Der blev brugt en gavekortskode ${GIFT_CARD_CODE} på ${GIFT_CARD_AMOUNT} til denne ordre.",
    GIFT_CARD: "Gavekort",
    REVERSAL_INVOICE: "Stornoregning",
    REVERSAL_CREDIT_NOTE: "Annullering af kreditnota",
    DUTY: "Toldafgifter",
    USED_DISCOUNTS: "Anvendte rabatter",
    PAYMENT_AT: "Betaling den $DATE",
    REFUNDED_CREDITNOTE_AT: "Tilbagebetaling af kreditnota $CREDIT_NOTE den $DATE",
    REFUNDED_AT: "Tilbagebetaling den $DATE",
    PROCESSING_DOCUMENT: "Dokumentet bliver bearbejdet",
    DOWNLOAD_DOCUMENTS_TITLE: "Hent dine dokumenter her!",
    MAIL_INTRODUCTION: "Hvis du har spørgsmål, kan du kontakte ${MAIL}",
    REPAYMENT_DIFFERENCE: "Tilbagebetalingsforskel",
    DOCUMENT_PREVIEW_BANNER: "Forhåndsvisning – download venligst PDF",
};
